/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const handleToggle = () =>{
document.getElementById("body-main").classList.toggle("mobile-menu-visible")
  }
  return (
    <>
      {/* <!-- Main Header--> */}

      <header class="main-header header-style-one">
        {/* <!-- Header top --> */}

        <div class="header-top">
          <div class="auto-container">
            <div class="inner-container">
              <div class="top-left">
                <ul class="social-icon-one ">
                  <li>
                    <a href="#" className="color-change">
                      <span class="fab fa-dribbble"></span>
                    </a>
                  </li>

                  <li>
                    <a href="#" className="color-change">
                      <span class="fab fa-facebook-f"></span>
                    </a>
                  </li>

                  <li>
                    <a href="#" className="color-change">
                      <span class="fab fa-twitter"></span>
                    </a>
                  </li>

                  <li>
                    <a href="#" className="color-change">
                      <span class="fab fa-pinterest-p"></span>
                    </a>
                  </li>
                </ul>
              </div>

              <div class="top-right">
                <ul class="contact-list-one">
                  <li>
                    <i class="flaticon-location"></i> 203 Madison Ave, NY, USA{" "}
                    <strong>Address</strong>
                  </li>

                  <li>
                    <i class="flaticon-alarm-clock-1"></i>Monday - Friday 9am -
                    6pm <strong>Timing</strong>
                  </li>

                  <li>
                    <i class="flaticon-email-1"></i>{" "}
                    <a href="mailto:boba@gmail.com">boba@gmail.com</a>{" "}
                    <strong>Mail to us</strong>
                  </li>
                </ul>

                <button class="nav-toggler">
                  <i class="flaticon flaticon-menu-2" ></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- End Header Top --> */}

        {/* <!-- Header Lower --> */}

        <div class="header-lower">
          <div class="auto-container">
            {/* <!-- Main box --> */}

            <div class="main-box">
              <div class="logo-box">
                <div class="logo">
                  <a href="index-2.html">
                    <img src="images/logo.png" alt="" title="" />
                  </a>
                </div>
              </div>

              <div class="nav-outer">
                {/* <!-- Main Menu --> */}

                <nav class="main-menu navbar-expand-lg">
                  <div
                    class="navbar-collapse collapse clearfix"
                    id="navbarSupportedContent"
                  >
                    <ul class="navigation clearfix">
                      <li class="">
                        <Link  className="btn-changu" to="/">HOME</Link>
                      </li>

                      <li class="">
                        <Link className="btn-changu" to="/about">ABOUT</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/agenda">AGENDA</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/accommodation">ACCOMMODATION</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/attend">ATTEND</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/speakers">SPEAKERS</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/sponsors">SPONSORS</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/nominees">NOMINEES
                        </Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/store">STORE</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/packages">PACKAGES</Link>
                      </li>
                      <li class="">
                        <Link className="btn-changu" to="/join">JOIN</Link>
                      </li>

                      <li>
                        <Link className="btn-changu" to="/contact">CONTACT</Link>
                      </li>
                    </ul>
                  </div>
                </nav>

                {/* <!-- Main Menu End--> */}

                {/* <div class="outer-box clearfix"> */}
                  {/* <!-- Search Btn --> */}

                 
                  {/* <!-- Quote Btn --> */}

                  {/* <div class="btn-box">
                    <a href="schedule.html" class="theme-btn btn-style-one">
                      <span class="btn-title">
                        <i class="flaticon-chair"></i> Donate
                      </span>
                    </a>
                  </div> */}
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Sticky Header  --> */}

        <div class="sticky-header">
          <div class="auto-container">
            <div class="main-box">
              <div class="logo-box">
                <div class="logo">
                  <a href="index-2.html">
                    <img src="images/logo.png" alt="" title="" />
                  </a>
                </div>

                <div class="upper-right">
                  <div class="search-box">
                    <button class="search-btn mobile-search-btn">
                      <i class="flaticon-search-2"></i>
                    </button>
                  </div>

                  <a
                    href="#nav-mobile"
                    class="mobile-nav-toggler navbar-trigger"
                  >
                    <i class="flaticon-menu" onClick={handleToggle}></i>
                  </a>
                </div>
              </div>

              <nav class="main-menu navbar-expand-md">
                {/* <!--Keep This Empty / Menu will come through Javascript--> */}
              </nav>
            </div>
          </div>
        </div>
        {/* <!-- End Sticky Menu --> */}

        {/* <!-- Mobile Header --> */}

        <div class="mobile-header">
          <div class="logo">
            <a href="index-2.html">
              <img src="images/logo.png" alt="" title="" />
            </a>
          </div>

          {/* <!--Nav Box--> */}

          <div class="nav-outer clearfix">
            <div class="outer-box">
              {/* <!-- Search Btn --> */}

              <div class="search-box">
                <button class="search-btn mobile-search-btn">
                  <i class="flaticon-search-2"></i>
                </button>
              </div>

              <a href="#nav-mobile" class="mobile-nav-toggler navbar-trigger">
                <i class="flaticon-menu" onClick={handleToggle}></i>
              </a>
            </div>
          </div>
        </div>

        {/* <!-- Mobile Menu  --> */}

        <div class="mobile-menu">
          <div class="menu-backdrop"></div>

          {/* <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header--> */}

          <nav class="menu-box">
            <div class="upper-box">
              <div class="nav-logo">
                <a href="index-2.html">
                  <img src="images/logo.png" alt="" title="" />
                </a>
              </div>

              <div class="close-btn">
                <i class="icon flaticon-close" onClick={handleToggle}></i>
              </div>
            </div>

            <ul class="navigation clearfix">
            <ul class="navigation clearfix">
                      <li class="">
                        <Link to="/">HOME</Link>
                      </li>

                      <li class="">
                        <Link to="/about">ABOUT</Link>
                      </li>
                      <li class="">
                        <Link to="/agenda">AGENDA</Link>
                      </li>
                      <li class="">
                        <Link to="/accommodation">ACCOMMODATION</Link>
                      </li>
                      <li class="">
                        <Link to="/attend">ATTEND</Link>
                      </li>
                      <li class="">
                        <Link to="/speakers">SPEAKERS</Link>
                      </li>
                      <li class="">
                        <Link to="/sponsors">SPONSORS</Link>
                      </li>
                      <li class="">
                        <Link to="/nominees">NOMINEES
                        </Link>
                      </li>
                      <li class="">
                        <Link to="/store">STORE</Link>
                      </li>
                      <li class="">
                        <Link to="/packages">PACKAGES</Link>
                      </li>
                      <li class="">
                        <Link to="/join">JOIN</Link>
                      </li>

                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
              {/* <!--Keep This Empty / Menu will come through Javascript--> */}
            </ul>

            <ul class="contact-list-one">
              <li>
                <i class="flaticon-location"></i> 203 Madison Ave, NY, USA{" "}
                <strong>Address</strong>
              </li>

              <li>
                <i class="flaticon-alarm-clock-1"></i>Monday - Friday 9am - 6pm{" "}
                <strong>Timing</strong>
              </li>

              <li>
                <i class="flaticon-email-1"></i>{" "}
                <Link to="mailto:Boba@gmail.com"></Link>{" "}
                <strong>Mail to us</strong>
              </li>
            </ul>

            <ul class="social-links">
              <li>
                <a href="#">
                  <span class="fab fa-facebook-f"></span>
                </a>
              </li>

              <li>
                <a href="#">
                  <span class="fab fa-pinterest"></span>
                </a>
              </li>

              <li>
                <a href="#">
                  <span class="fab fa-twitter"></span>
                </a>
              </li>

              <li>
                <a href="#">
                  <span class="fab fa-dribbble"></span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        {/* <!-- End Mobile Menu --> */}

        {/* <!-- Header Search --> */}

        <div class="search-popup">
          <button class="close-search">
            <i class="flaticon-close"></i>
          </button>

          <form
            method="post"
            action="https://themecraze.net/html/volia/blog.html"
          >
            <div class="form-group">
              <input
                type="search"
                name="search-field"
                value=""
                placeholder="Search"
                required=""
              />

              <button type="submit">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </form>
        </div>

        {/* <!-- End Header Search --> */}
      </header>

      {/* <!--End Main Header --> */}

      {/* <!-- Hidden bar back drop --> */}

      <div class="form-back-drop"></div>
    </>
  );
};

export default Header;
